var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.market)?_c('ActiveMarketsItemAdvanced',{attrs:{"market":_vm.market,"checkOnlyDisable":false}}):_c('div',{staticClass:"text-xs-center pa-3"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" "),_c('h1',[_vm._v("Loading...")])],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20dfcdbb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/markets/MarketAllocationsExpandedSettings.vue
// module id = yOXJ
// module chunks = 0